import { createGridLayout, createGridItem } from "../../../../store/global/gridlayout";

export const customTextGrid = createGridLayout({
  layout: [
    createGridItem({
      x: 0,
      y: 0,
      w: 60,
      h: 50,
      i: 'offer_mail_to_artist',
    }),
    createGridItem({
      x: 0,
      y: 50,
      w: 60,
      h: 5,
      i: 'booking_request1',
    }),
    createGridItem({
      x: 0,
      y: 55,
      w: 60,
      h: 50,
      i: 'booking_request',
    }),
    createGridItem({
      x: 0,
      y: 105,
      w: 60,
      h: 5,
      i: 'questionnaire_l1',
    }),
    createGridItem({
      x: 0,
      y: 110,
      w: 60,
      h: 50,
      i: 'questionnaire_l',
    }),
    createGridItem({
      x: 0,
      y: 150,
      w: 60,
      h: 5,
      i: 'documents_Templatesl',
    }),
    createGridItem({
      x: 0,
      y: 155,
      w: 60,
      h: 50,
      i: 'send_document_and_files',
    }),
    createGridItem({
      x: 0,
      y: 160,
      w: 60,
      h: 5,
      i: 'assistant_intelligence',
    }),
    createGridItem({
      x: 0,
      y: 165,
      w: 60,
      h: 50,
      i: 'submenu_Templates',
    }),

  ]
});